import { SiteControllerSettingNotUsingInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { z } from "zod";

export const siteControllerSettingNotUsingInputZodSchema = SiteControllerSettingNotUsingInputSchema;

export type SiteControllerSettingNotUsingInputZodSchemaType = z.infer<
	typeof siteControllerSettingNotUsingInputZodSchema
>;
